class Select extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="select">
          Select
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#elements-mixin-select" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Select box</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<div class="select-demo">
  Dark theme
  <div class="select dark">
    <select>
      <option value="articuno">Articuno</option>
      <option value="zapdos">Zapdos</option>
      <option value="moltres">Moltres</option>
    </select>
  </div>

  Dark Disabled
  <div class="select dark-disabled">
    <select>
      <option value="articuno">Articuno</option>
      <option value="zapdos">Zapdos</option>
      <option value="moltres">Moltres</option>
    </select>
  </div>

  Light theme
  <div class="select light">
    <select>
      <option value="articuno">Articuno</option>
      <option value="zapdos">Zapdos</option>
      <option value="moltres">Moltres</option>
    </select>
  </div>

  Light disabled
  <div class="select light-disabled">
    <select>
      <option value="articuno">Articuno</option>
      <option value="zapdos">Zapdos</option>
      <option value="moltres">Moltres</option>
    </select>
  </div>
</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.select-demo {
  .select {
    margin-bottom: 20px;
  }

  .dark {
    @include select();
  }

  .light {
    @include select(light);
  }

  .dark-disabled {
    @include select($disabled: true);
  }

  .light-disabled {
    @include select(light, true);
  }
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="select-demo">
                    Dark theme
                    <div className="dark">
                      <select>
                        <option value="articuno">Articuno</option>
                        <option value="zapdos">Zapdos</option>
                        <option value="moltres">Moltres</option>
                      </select>
                    </div>

                    Dark disbaled
                    <div className="dark-disabled">
                      <select disabled={true}>
                        <option value="articuno">Articuno</option>
                        <option value="zapdos">Zapdos</option>
                        <option value="moltres">Moltres</option>
                      </select>
                    </div>

                    Light theme
                    <div className="light">
                      <select>
                        <option value="articuno">Articuno</option>
                        <option value="zapdos">Zapdos</option>
                        <option value="moltres">Moltres</option>
                      </select>
                    </div>

                    Light disabled
                    <div className="light-disabled">
                      <select disabled={true}>
                        <option value="articuno">Articuno</option>
                        <option value="zapdos">Zapdos</option>
                        <option value="moltres">Moltres</option>
                      </select>
                    </div>
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
